import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchNotifications,
  markNotificationAsRead,
  deleteNotification,
  clearUserNotifications,
  markAllAsRead,
  dismissNotification,
} from "../../redux/slices/notificationSlice";

const Notification = ({ onClose, currentUser }) => {
  const dispatch = useDispatch();

  const { isAuthenticated, user: reduxUser } = useSelector(
    (state) => state.auth
  );

 const { items: notifications, loading } = useSelector(
  (state) => state.notification
);

  const user = currentUser || reduxUser;

  // ✅ SAFE ARRAY
  const safeNotifications = Array.isArray(notifications)
    ? notifications
    : [];

  // ================= FETCH =================
  useEffect(() => {
    if (!user?._id || !isAuthenticated) return;

    dispatch(
      fetchNotifications({
        userId: user._id,
        unreadOnly: false,
      })
    );
  }, [user?._id, isAuthenticated, dispatch]);

  if (!user) return null;

  if (loading) {
    return (
      <p className="text-center text-gray-500">
        Loading notifications...
      </p>
    );
  }

  // ================= COUNT =================
  const unreadCount =
    safeNotifications.filter((n) => !n.isRead).length;

  return (
    <div className="p-4 max-w-md mx-auto bg-white rounded-lg shadow-md">
      {/* HEADER */}
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-bold flex items-center gap-2">
          🔔 Notifications

          {unreadCount > 0 && (
            <span className="text-xs bg-red-500 text-white px-2 py-0.5 rounded-full">
              {unreadCount}
            </span>
          )}
        </h2>

        {onClose && (
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-red-500 text-sm px-2 py-1 rounded"
          >
            ✖
          </button>
        )}
      </div>

      {/* ACTIONS */}
      {safeNotifications.length > 0 && (
        <div className="flex justify-end gap-4 mb-3 text-sm">
          <button
            className="text-blue-500 hover:underline"
            onClick={() => dispatch(markAllAsRead(user._id))}  // ✅ FIXED
          >
            Mark All as Read
          </button>

          <button
            className="text-red-500 hover:underline"
            onClick={() => dispatch(clearUserNotifications(user._id))} // ✅ FIXED
          >
            Clear All
          </button>
        </div>
      )}

      {/* LIST */}
      {safeNotifications.length === 0 ? (
        <p className="text-sm text-gray-500 text-center">
          No notifications yet.
        </p>
      ) : (
        safeNotifications.map((note) => {
          const noteId = note._id || note.id;

          // ✅ normalize message ONCE
          const message =
            typeof note.message === "string"
              ? note.message
              : note.message?.text || "No message";

          return (
            <div
              key={noteId}
              className={`relative bg-white rounded shadow p-3 mb-3 border ${
                note.isRead ? "border-gray-300" : "border-blue-400"
              }`}
            >
              {/* DELETE */}
              <button
                className="absolute top-3 right-3 text-xs text-red-400 hover:text-red-600"
                onClick={() =>
                  dispatch(
                    deleteNotification({
                      notificationId: noteId,
                      userId: user._id,
                    })
                  )
                }
              >
                ❌
              </button>

              {/* MESSAGE */}
              <p className="text-sm font-medium">{message}</p>

              <p className="text-xs text-gray-400 mt-1">
                Status: {note.isRead ? "Read" : "Unread"}
              </p>

              {/* ACTIONS */}
              <div className="mt-2 flex gap-3 text-xs">
                {!note.isRead && (
                  <button
                    className="text-blue-500 hover:underline"
                    onClick={() =>
                      dispatch(
                        markNotificationAsRead({
                          notificationId: noteId,
                          userId: user._id,
                        })
                      )
                    }
                  >
                    Mark as Read
                  </button>
                )}

                <button
                  className="text-gray-500 hover:underline"
                  onClick={() =>
                    dispatch(dismissNotification(noteId))
                  }
                >
                  Dismiss
                </button>
              </div>
            </div>
          );
        })
      )}
    </div>
  );
};

export default Notification;